import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalizeLower'
})
export class CapitalizeLowerPipe implements PipeTransform {
    transform(str: string): string {
        if (!str) return '';

        return str.toLowerCase().replace(/_/g, ' ');
    }

}
